import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BackupEmpresaService {

  constructor() { }


  diretoriaExecutiva(){
    return [
      {
      nome: 'Wellington Zaytcho Vitti',
      path: 'assets/imagens/diretoria-executiva/WZV.JPG',
      sobre: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry'
      }
    ]
  }

  //Samuel --
  EmpresaGraduada(){
    return [
      {
        nome: 'Acme',
        path: 'assets/imagens/empresas/graduadas/Acme.png'
      },
      {
        nome: 'Clean-up',
        path: 'assets/imagens/empresas/graduadas/Clean-up.png'
      },
      {
        nome: 'MGE',
        path: 'assets/imagens/empresas/graduadas/MGE.png'
      },
      {
        nome: 'Ortus',
        path: 'assets/imagens/empresas/graduadas/Ortus.png'
      },
      {
        nome: 'Sieger',
        path: 'assets/imagens/empresas/graduadas/Sieger.png'
      },
      {
        nome: 'Saubern',
        path: 'assets/imagens/empresas/graduadas/Saubern.png'
      },
    ]
  }

  //Otávio -
  EmpresaIncubada(){
    return [
      {
        nome: 'AdvogaIA',
        logo: 'assets/imagens/empresas/incubada/AdvogaIA.png'
      },
      {
        nome: 'Apogeu',
        logo: 'assets/imagens/empresas/incubada/Apogeu.png'
      },
      {
        nome: 'Atla',
        logo: 'assets/imagens/empresas/incubada/Atla.png'
      },
      {
        nome: 'Biozone',
        logo: 'assets/imagens/empresas/incubada/Biozone.png'
      },
      {
        nome: 'Campkitchen',
        logo: 'assets/imagens/empresas/incubada/Campkitchen.png'
      },
      {
        nome: 'Carbonexplore',
        logo: 'assets/imagens/empresas/incubada/Carbonexplore.png'
      },
      {
        nome: 'Caule',
        logo: 'assets/imagens/empresas/incubada/Caule.png'
      },
      {
        nome: 'DaCapo',
        logo: 'assets/imagens/empresas/incubada/DaCapo.png'
      },
      {
        nome: 'Fitoquimica',
        logo: 'assets/imagens/empresas/incubada/Fitoquimica.png'
      },
      {
        nome: 'Ihcare',
        logo: 'assets/imagens/empresas/incubada/Ihcare.png'
      },
      {
        nome: 'Magvia',
        logo: 'assets/imagens/empresas/incubada/Magvia.png'
      },
      {
        nome: 'Metaltechne',
        logo: 'assets/imagens/empresas/incubada/Metaltechne.png'
      },
      {
        nome: 'Raiovis',
        logo: 'assets/imagens/empresas/incubada/Raiovis.png'
      },
      {
        nome: 'SosPulseira',
        logo: 'assets/imagens/empresas/incubada/SosPulseira.png'
      },
      {
        nome: 'Vibras',
        logo: 'assets/imagens/empresas/incubada/Vibras.png'
      }
    ]
  }


  //Não sei
  EmpresaMantenedora(){
    return [
      {
        nome: 'Cristófoli',
        path: 'assets/imagens/empresas/Mantenedoras/Cristofoli.png'
      },
      {
        nome: 'AgriSolus',
        path: 'assets/imagens/empresas/Mantenedoras/AgriSolus.png'
      },
      {
        nome: 'Agrocells',
        path: 'assets/imagens/empresas/Mantenedoras/Agrocells.png'
      },
      {
        nome: 'Biovis',
        path: 'assets/imagens/empresas/Mantenedoras/Biovis.png'
      },
      {
        nome: 'Celf',
        path: 'assets/imagens/empresas/Mantenedoras/Celf.png'
      },
      {
        nome: 'Evolutec',
        path: 'assets/imagens/empresas/Mantenedoras/Evolutec.png'
      },
      {
        nome: 'Levevida',
        path: 'assets/imagens/empresas/Mantenedoras/Levevida.png'
      },
      {
        nome: 'Lizze',
        path: 'assets/imagens/empresas/Mantenedoras/Lizze.png'
      },
      {
        nome: 'Ponce',
        path: 'assets/imagens/empresas/Mantenedoras/Ponce.png'
      },
      {
        nome: 'Vollenz',
        path: 'assets/imagens/empresas/Mantenedoras/Vollenz.png'
      },
    ]
  }
}
